import axiosClient from "./axiosClient";

const recordFileApi = {

    get: (fileName) => {
        const url = `/files/${fileName}`;

        return axiosClient.get(url, {
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem("token"),
                'Content-Type': 'image/jpeg'
            },
            responseType: 'blob'
        });
    }
}

export default recordFileApi;